import { render } from "./NewSubscribersPage.vue?vue&type=template&id=cdbe4638"
import script from "./NewSubscribersPage.vue?vue&type=script&lang=js"
export * from "./NewSubscribersPage.vue?vue&type=script&lang=js"

import "./NewSubscribersPage.vue?vue&type=style&index=0&id=cdbe4638&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__